import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
const CopyRight = (props: Record<string, unknown>) => {
  const { t } = useTranslation()
  return (
    <Typography variant='subtitle2' color='secondary.main' align='center' {...props}>
      {'© '}
      {new Date().getFullYear()} {t('copyRight.copyRightText')}

    </Typography>
  )
}

export default CopyRight
